const AgeGroup = require('./AgeGroup');

class ProviderFile {
  constructor() {
    this.init();
  }

  init() {
    this.provider_file_id = undefined;
    this.provider_id = undefined;
    this.center_id = undefined;
    this.display_name = undefined;
    this.url = undefined;
    this.include_in = undefined;
    this.special_type = undefined;
    this.ageGroups = undefined;
  }

  copy() {
    const cp = new ProviderFile();

    cp.provider_file_id = this.provider_file_id;
    cp.provider_id = this.provider_id;
    cp.center_id = this.center_id;
    cp.display_name = this.display_name;
    cp.url = this.url;
    cp.include_in = this.include_in;
    cp.special_type = this.special_type;
    if (this.ageGroups) {
      cp.ageGroups = [];
      this.ageGroups.forEach((a) => {
        cp.ageGroups.push(a.copy());
      });
    }

    return cp;
  }

  buildFromJSON(obj) {
    this.init();
    if (obj) {
      this.provider_file_id = obj.provider_file_id ? obj.provider_file_id.toString() : undefined;
      this.provider_id = obj.provider_id ? obj.provider_id.toString() : undefined;
      this.center_id = obj.center_id ? obj.center_id.toString() : undefined;
      this.display_name = obj.display_name ? obj.display_name : undefined;
      this.url = obj.url ? obj.url : undefined;
      this.include_in = obj.include_in ? obj.include_in : undefined;
      this.special_type = obj.special_type ? obj.special_type : undefined;

      if (obj.ageGroups) {
        this.ageGroups = [];
        obj.ageGroups.forEach((a) => {
          const ageGroup = new AgeGroup();
          ageGroup.buildFromJSON(c);
          this.ageGroups.push(ageGroup);
        });
      }
    }
  }

  toString() {
    let result = this.name ? this.name : '';
    return result;
  }

  getId() {
    return this.provider_file_id;
  }

  setId(provider_file_id) {
    this.provider_file_id = provider_file_id ? provider_file_id.toString() : undefined;
  }
  
  getProviderId() {
    return this.provider_id;
  }

  setProviderId(provider_id) {
    this.provider_id = provider_id ? provider_id.toString() : undefined;
  }

  getCenterId() {
    return this.center_id;
  }

  setCenterId(center_id) {
    this.center_id = center_id ? center_id.toString() : undefined;
  }

  getDisplayName() {
    return this.display_name;
  }

  setDisplayName(display_name) {
    this.display_name = display_name;
  }

  getURL() {
    return this.url;
  }

  setURL(url) {
    this.url = url;
  }

  getIncludeIn() {
    return this.include_in;
  }

  setIncludeIn(include_in) {
    this.include_in = include_in;
  }

  getSpecialType() {
    return this.special_type;
  }

  setSpecialType(special_type) {
    this.special_type = special_type;
  }

  getAgeGroups() {
    if (!this.ageGroups) {
      return undefined;
    }
    
    return this.ageGroups;
  }

  setContracts(ageGroups) {
    this.ageGroups = undefined;
    if (ageGroups) {
      this.ageGroups = [];
      ageGroups.forEach((a) => {
        this.ageGroups.push(a.copy());
      });
    }
  }
}

module.exports = ProviderFile;
